import React, { FC, useContext } from "react";
import { SortBy } from "../../models/SortBy";
import { TableColumn } from "../../models/table/TableColumn";
import { ContextToggle } from "./ContextToggle";

export interface SortContextValueType extends ContextToggle {
    tableDescriptor: TableColumn[];
    updateDirection: (columnId?: number | string) => void;
}

export const emptySortContextValue = {
    isInUse: false,
    tableDescriptor: new Array(0),
    updateDirection: () => { },
};

export const SortContext = React.createContext<SortContextValueType>(emptySortContextValue);

export const useSort = () => {
    return useContext(SortContext);
};
